/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendCapexVariantDto } from '../../models/backend-capex-variant-dto';

export interface EconomicIndicatorsCapexVariantsRetrieve$Params {
  /**
   * A unique integer value identifying this capex variant.
   */
  id: number;
}

export function economicIndicatorsCapexVariantsRetrieve(
  http: HttpClient,
  rootUrl: string,
  params: EconomicIndicatorsCapexVariantsRetrieve$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendCapexVariantDto>> {
  const rb = new RequestBuilder(rootUrl, economicIndicatorsCapexVariantsRetrieve.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendCapexVariantDto>;
    }),
  );
}

economicIndicatorsCapexVariantsRetrieve.PATH = '/api/economic_indicators/capex_variants/{id}/';
